import React from "react";
import { useForm } from "react-hook-form";
import { format } from "date-fns";
import { ru } from "date-fns/locale";

/**
 * Компонент для выбора диапазона дат
 */
const DateRangePicker = ({ startDate, endDate, onChange }) => {
    const { register, handleSubmit, watch } = useForm({
        defaultValues: {
            startDate: startDate ? format(startDate, "yyyy-MM-dd") : "",
            endDate: endDate ? format(endDate, "yyyy-MM-dd") : "",
        },
    });

    const onSubmit = (data) => {
        if (onChange) {
            onChange({
                start: new Date(data.startDate),
                end: new Date(data.endDate),
            });
        }
    };

    return (
        <form onChange={handleSubmit(onSubmit)}>
            <div className="flex flex-row gap-2">
                <input
                    type="date"
                    {...register("startDate")}
                    max={watch("endDate")}
                    className="w-full p-2 rounded bg-[#1E1E1E] border border-[#3E3E42] text-white focus:outline-none focus:border-[#007ACC] mt-2"
                />

                <input
                    type="date"
                    {...register("endDate")}
                    min={watch("startDate")}
                    className="w-full p-2 rounded bg-[#1E1E1E] border border-[#3E3E42] text-white focus:outline-none focus:border-[#007ACC] mt-2"
                />
            </div>
        </form>
    );
};

export default DateRangePicker;
